export const NEW_INBOX_ID = 'new_inbox'
export const ASSIGN_LATER_ID = 'assign_later'
